// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1vbPV","consentsList":"PatientConsents_consentsList__1a9VD","consentsListEmpty":"PatientConsents_consentsListEmpty__2BTLt"};